/*
https://www.reactnativeschool.com/normalizing-text-and-spacing-between-screen-sizes
*/
import { PixelRatio, Dimensions, StyleSheet } from "react-native";

const ratio = PixelRatio.get();

const { width, height } = Dimensions.get("window");

export const normalize = (size) => {
  if (!Number.isInteger(size)) {
    return size;
  }
  if (ratio >= 2 && ratio < 3) {
    if (width < 360) {
      return PixelRatio.roundToNearestPixel(size * 0.95);
    } else if (height < 667) {
      return PixelRatio.roundToNearestPixel(size);
    } else if (height >= 667 && height <= 735) {
      return PixelRatio.roundToNearestPixel(size * 1.15);
    }

    return PixelRatio.roundToNearestPixel(size * 1.25);
  } else if (ratio >= 3 && ratio < 3.5) {
    if (width < 360) {
      return PixelRatio.roundToNearestPixel(size);
    } else if (height < 667) {
      return PixelRatio.roundToNearestPixel(size * 1.15);
    } else if (height >= 667 && height <= 735) {
      return PixelRatio.roundToNearestPixel(size * 1.2);
    }

    return PixelRatio.roundToNearestPixel(size * 1.27);
  } else if (ratio >= 3.5) {
    if (width < 360) {
      return PixelRatio.roundToNearestPixel(size);
    } else if (height < 667) {
      return PixelRatio.roundToNearestPixel(size * 1.2);
    } else if (height >= 667 && height <= 735) {
      return PixelRatio.roundToNearestPixel(size * 1.25);
    }

    return PixelRatio.roundToNearestPixel(size * 1.4);
  }

  return PixelRatio.roundToNearestPixel(size);
};

export const create = (
  styles,
  targetProperties = [
    // "fontSize",
    // "lineHeight",
    "margin",
    "marginHorizontal",
    "marginVertical",
    "padding",
    "paddingVertical",
    "paddingHorizontal",
    "height",
    "width",
    "minHeight",
    "minWidth",
    "borderRadius",
  ],
) => {
  const normalizedStyles = {};
  Object.keys(styles).forEach((key) => {
    normalizedStyles[key] = {};
    Object.keys(styles[key]).forEach((property) => {
      if (targetProperties.includes(property)) {
        normalizedStyles[key][property] = normalize(styles[key][property]);
      } else {
        normalizedStyles[key][property] = styles[key][property];
      }
    });
  });

  return StyleSheet.create(normalizedStyles);
};
